// src/components/common/AnalyticsTracker.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Envía un evento "pageview" a Google Analytics con la nueva ruta
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search,
    });
  }, [location]); // Este efecto se ejecuta cada vez que la URL cambia

  return null; // Este componente no renderiza nada en la pantalla
};

export default AnalyticsTracker;
